import React, { useState } from "react";

// Redux stuff
import { connect } from "react-redux";
import { createProject } from "../../redux/actions/providerActions";

import styles from "./addNewProject.module.css";

import Button from "@material-ui/core/Button";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import TextField from "@material-ui/core/TextField";

const AddNewProject = (props) => {
    const [state, setState] = useState({
        title: "",
        description: "",
        images: [],
        technologies: [],
        topics: [],
        projectLinks: [],
        selectedTag: "technologies",
        addTagText: "",
    });

    const { newProjectState } = props;

    const {
        title,
        description,
        technologies,
        topics,
        images,
        projectLinks,
        selectedTag,
        addTagText,
    } = state;

    const handleChange = (e) => {
        setState((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
        console.log(state);
    };

    const tagSave = (e) => {
        if (
            e.key === "Enter" &&
            state[selectedTag].length <= 4 &&
            addTagText.length !== 0
        ) {
            setState((prevState) => ({
                ...prevState,
                [selectedTag]: [...state[selectedTag], addTagText],
                addTagText: "",
            }));
        }
    };

    const deleteTechnology = (index) => {
        technologies.splice(index, 1);
        setState((prevState) => ({
            ...prevState,
        }));
    };

    const deleteTopic = (index) => {
        topics.splice(index, 1);
        setState((prevState) => ({
            ...prevState,
        }));
    };

    const deleteProjectLink = (index) => {
        projectLinks.splice(index, 1);
        setState((prevState) => ({
            ...prevState,
        }));
    };

    const handleSubmit = () => {
        const data = {
            title,
            description,
            technologies,
            topics,
            images,
            projectLinks,
            userId: props.provider.userData._id,
        };
        props.createProject(data, newProjectState);
    };

    return (
        <div className={styles.projectShowcaseContainer}>
            <div className={styles.left}>
                <TextField
                    name="title"
                    value={title}
                    onChange={handleChange}
                    className={styles.projectTitle}
                    label="Enter Project Name"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <h4 className={styles.projectNote}>
                    This project will be displayed on your profile
                </h4>
                <div className={styles.projectDescriptionContainer}>
                    <h4 className={styles.projectDescriptionTitle}>
                        Project Description
                    </h4>
                    <TextareaAutosize
                        name="description"
                        value={description}
                        onChange={handleChange}
                        rowsMin={5}
                        placeholder="Minimum 5 rows"
                        className={styles.projectDescriptionInput}
                    />
                </div>
                <h4 className={styles.projectImageTitle}>
                    <button>Upload Related Images</button>
                </h4>
                <input
                    accept="image/*"
                    className={styles.hiddenImageButton}
                    id="contained-button-file"
                    multiple
                    type="file"
                />
                <label htmlFor="contained-button-file">
                    <Button
                        variant="contained"
                        className={styles.imageUploadPlaceholder}
                        component="span"
                    >
                        Upload
                    </Button>
                </label>
            </div>
            <div className={styles.right}>
                <h4 className={styles.technologiesHeading}>
                    Add Technologies/Topics/Project Links
                </h4>
                <div className={styles.addTagsContainer}>
                    <input
                        name="addTagText"
                        value={addTagText}
                        onChange={handleChange}
                        className={styles.addTags}
                        placeholder={`Add ${
                            selectedTag === "technologies"
                                ? "Technology"
                                : selectedTag === "topics"
                                ? "Topic"
                                : selectedTag === "projectLinks"
                                ? "Project Link"
                                : ""
                        }`}
                        onKeyPress={tagSave}
                    />
                    <select
                        name="selectedTag"
                        value={selectedTag}
                        onChange={handleChange}
                        className={styles.tagsSelector}
                    >
                        <option value="technologies">Technology</option>
                        <option value="topics">Topic</option>
                        <option value="projectLinks">Project Link</option>
                    </select>
                </div>
                <h4 className={styles.technologiesHeading}>Technologies</h4>
                <div className={styles.technologiesContainer}>
                    {technologies.length === 0 && (
                        <span title="Example">Example: Machine Learning</span>
                    )}
                    {technologies.length > 0 &&
                        technologies.map((each, index) => {
                            return (
                                <span
                                    title="Delete Technology"
                                    onClick={() => deleteTechnology(index)}
                                    key={index}
                                >
                                    {each}
                                </span>
                            );
                        })}
                </div>
                <h4 className={styles.technologiesHeading}>Topics</h4>
                <div className={styles.technologiesContainer}>
                    {topics.length === 0 && (
                        <span title="Example">
                            Example: E-Commerce Platform
                        </span>
                    )}
                    {topics.length > 0 &&
                        topics.map((each, index) => {
                            return (
                                <span
                                    title="Delete Topic"
                                    onClick={() => deleteTopic(index)}
                                    key={index}
                                >
                                    {each}
                                </span>
                            );
                        })}
                </div>
                <h4 className={styles.technologiesHeading}>Project Links</h4>
                <div className={styles.technologiesContainer}>
                    {projectLinks.length === 0 && (
                        <span title="Example">
                            Example: https://project.link.com
                        </span>
                    )}
                    {projectLinks.length > 0 &&
                        projectLinks.map((each, index) => {
                            return (
                                <span
                                    title="Delete Project Link"
                                    onClick={() => deleteProjectLink(index)}
                                    key={index}
                                >
                                    {each}
                                </span>
                            );
                        })}
                </div>
            </div>

            <button
                onClick={handleSubmit}
                className={` ${styles.saveButton} ${styles.saveButtonColor}`}
            >
                Save
            </button>
        </div>
    );
};

const mapStateToProps = (state) => ({
    provider: state.provider,
});

export default connect(mapStateToProps, { createProject })(AddNewProject);
